import React, { useEffect } from 'react'
import styled from '@emotion/styled'

const OverviewLogo = styled.img`
  max-width: 200px;
  display: block;
  margin: 0 auto;
`

export default OverviewLogo